/**
 * The subscreen renders the response-style tab as a slot, so their `import()`s
 * would otherwise chain (the tab chunk would not fetch until the subscreen chunk
 * resolved and mounted). Kicking off both imports up front lets the chunks
 * download in parallel instead of serially.
 */
export const importResponseWritingStyleSubScreen = (): Promise<
	typeof import('@atlassian/rovo-personalization/ui/response-writing-style-subscreen')
> =>
	import(
		/* webpackChunkName: "@atlassian/rovo-personalization-response-writing-style-subscreen" */
		'@atlassian/rovo-personalization/ui/response-writing-style-subscreen'
	);

export const importResponseStyleTab = (): Promise<
	typeof import('@atlassian/rovo-personalization/ui/response-style-tab')
> =>
	import(
		/* webpackChunkName: "@atlassian/rovo-personalization-response-style-tab" */
		'@atlassian/rovo-personalization/ui/response-style-tab'
	);

/** Warms both lazy chunks concurrently so neither waits on the other. */
export const prefetchResponseWritingStyleChunks = (): void => {
	// Warm-up only; a failed fetch is retried when the component actually renders.
	void importResponseWritingStyleSubScreen().catch(() => {});
	void importResponseStyleTab().catch(() => {});
};
